import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { ToastData } from '@ui/toast/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: ToastData,
    private snackRef: MatSnackBarRef<ToastComponent>
  ) { }

  dismiss() {
    this.snackRef.dismiss();
  }

  ngOnInit() {
  }

}
